import service from "./service";

const login = async (payload) => {
  return service.post("/auth/email/login", payload).then((response) => {
    return response;
  });
};

const verifyToken = async () => {
  return service.get("/auth/me").then((response) => {
    return response;
  });
};

// Exchanges a Firebase ID token for an app session token.
const firebaseLogin = async (payload) => {
  return service.post("/auth/firebase", payload).then((response) => {
    return response;
  });
};

const signup = async (payload) => {
  return service.post("/auth/email/register", payload).then((response) => {
    return response;
  });
};

// Confirms an email/password account with the OTP that was mailed out.
const verifyEmail = async (payload) => {
  return service.post("/auth/email/verify", payload).then((response) => {
    return response;
  });
};

const resendVerification = async (payload) => {
  return service
    .post("/auth/email/resend-verification", payload)
    .then((response) => {
      return response;
    });
};

// Step 1 of forgot-password: mails a reset code.
const forgotPassword = async (payload) => {
  return service.post("/auth/password/forgot", payload).then((response) => {
    return response;
  });
};

// Step 2: checks the code on its own, before asking for a new password.
const verifyResetOtp = async (payload) => {
  return service.post("/auth/password/verify-otp", payload).then((response) => {
    return response;
  });
};

// Step 3: sets the password. No code here - step 2 must have succeeded first.
const resetPassword = async (payload) => {
  return service.post("/auth/password/reset", payload).then((response) => {
    return response;
  });
};

const authService = {
  forgotPassword,
  verifyResetOtp,
  resetPassword,
  login,
  verifyToken,
  firebaseLogin,
  signup,
  verifyEmail,
  resendVerification,
};

export default authService;
